import { defineComponent as e, toRef as a, computed as l, ref as t, watch as u, h as n } from "vue";
const o = { type: Function, required: false, default: () => {
} }, i = { padding: 0, border: 0, margin: 0 }, r = { willChange: "height" }, s = e({ name: "Collapse", inheritAttrs: true, props: { when: { type: Boolean, required: true }, baseHeight: { type: Number, required: false, default: 0 }, as: { type: String, required: false, default: "div" }, onExpand: o, onExpanded: o, onCollapse: o, onCollapsed: o }, setup(e2, { slots: o2 }) {
  const s2 = a(e2, "when"), d2 = a(e2, "baseHeight"), p = l(() => {
    const e3 = { overflow: "hidden", height: `${d2.value}px` };
    return { visible: e3, collapsed: { ...i, ...0 === d2.value ? { display: "none" } : e3 } };
  }), h = t(null), g = t(s2.value ? i : p.value.collapsed), c = t(s2.value ? "expanded" : "collapsed");
  function m(a2) {
    var _a, _b;
    a2.target === h.value && "height" === a2.propertyName && (s2.value ? ((_a = h.value) == null ? void 0 : _a.scrollHeight) === parseFloat(a2.target.style.height) && (g.value = i, c.value = "expanded", e2.onExpanded()) : ((_b = h.value) == null ? void 0 : _b.style.height) === `${d2.value}px` && (g.value = p.value.collapsed, c.value = "collapsed", e2.onCollapsed()));
  }
  return u(s2, (a2) => {
    requestAnimationFrame(() => {
      var _a;
      a2 ? (g.value = { ...i, ...r, ...p.value.visible }, requestAnimationFrame(() => {
        var _a2;
        g.value = { ...g.value, ...v((_a2 = h.value) == null ? void 0 : _a2.scrollHeight, d2.value) }, c.value = "expanding", e2.onExpand();
      })) : (g.value = { ...g.value, ...r, ...v((_a = h.value) == null ? void 0 : _a.scrollHeight, d2.value) }, requestAnimationFrame(() => {
        g.value = { ...g.value, ...p.value.visible }, c.value = "collapsing", e2.onCollapse();
      }));
    });
  }), u(d2, (e3) => {
    s2.value || (g.value = { ...g.value, transitionDuration: "0s", height: `${e3}px` });
  }), () => {
    var _a;
    return n(e2.as, { ref: (e3) => h.value = e3, style: g.value, onTransitionend: m, "data-collapse": c.value }, (_a = o2.default) == null ? void 0 : _a.call(o2, { state: c.value }));
  };
} });
function v(e2 = 0, a2 = 0) {
  return { "--vc-auto-duration": `${d(e2 - a2)}ms`, height: `${e2}px` };
}
function d(e2 = 0) {
  if (0 === e2)
    return 0;
  const a2 = e2 / 36;
  return Math.round(10 * (4 + 15 * a2 ** 0.25 + a2 / 5));
}
export {
  s as Collapse
};
